import React from 'react';
import PropTypes from 'prop-types';

import { CircularProgress } from '@mui/material';
import { Flex } from '../../components';

export const LoadingBox = ({ sx, ...props }) => {
  return (
    <Flex.V
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        border: '1px solid #DDD',
        borderRadius: '4px',
        ...sx,
      }}
      {...props}
    >
      <CircularProgress size="50px" />
    </Flex.V>
  );
};

LoadingBox.propTypes = {
  sx: PropTypes.object,
  onClick: PropTypes.func,
};
